import { useEffect, useState } from 'react'

const CACHE_KEY = 'xident_app_versions'

interface AppVersions {
  api: string
  dashboard: string
  admin: string
  sdk: string
  docs: string
}

export function useAppVersion() {
  const [version, setVersion] = useState<string>('')
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const cached = sessionStorage.getItem(CACHE_KEY)
    if (cached) {
      try {
        const parsed: AppVersions = JSON.parse(cached)
        setVersion(parsed.admin)
        setIsLoading(false)
        return
      } catch {
        // ignore parse errors, re-fetch
      }
    }

    const base = import.meta.env.VITE_API_URL || ''
    fetch(`${base}/public/v1/versions`)
      .then((r) => r.json())
      .then((data: AppVersions) => {
        sessionStorage.setItem(CACHE_KEY, JSON.stringify(data))
        setVersion(data.admin)
      })
      .catch(() => {
        setVersion(import.meta.env.VITE_APP_VERSION || 'dev')
      })
      .finally(() => setIsLoading(false))
  }, [])

  return { version, isLoading }
}
